exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.inputfile {\n\twidth: 0.1px;\n\theight: 0.1px;\n\topacity: 0;\n\toverflow: hidden;\n\tposition: absolute;\n\tz-index: -1;\n}\n.inputfile + label {\n\tcolor: white;\n\tdisplay: inline-block;\n\tpadding: 0.5rem;\n\tborder-radius: 0.125rem;\n\tmargin-right: 15px;\n\tmargin-left: 0;\n}\n.inputfile + label:hover {\n\tcolor: #68ace1;\n\tcursor: pointer;\n}\n", ""]);

// exports
